import { NEWSLETTER_URL } from "../../../helpers/api.routes";
import { requests } from "../../../helpers/api.services";

export const NewsletterSettingsService = {
  getAll: () => requests.get(`${NEWSLETTER_URL}-settings`),
  create: (params: any) =>
    requests.post(`${NEWSLETTER_URL}-settings`, params, true),
  deleteImage: () => requests.delete(`${NEWSLETTER_URL}-settings`),
};
